/**
 * Display helpers for essence types. Essence itself is earned, spent and
 * coalesced on the crucible host; the client only shows it.
 */

import { ESSENCE_TYPE_NAMES, type EssenceType } from '@sorrem/shared';

/**
 * Get UI-friendly essence display string.
 */
export function formatEssenceAmount(type: EssenceType, amount: number): string {
  return `${amount} ${ESSENCE_TYPE_NAMES[type]}`;
}

/**
 * Each essence type's color: the one place it is set. The UI, the orbs in the
 * world (through their shader), the mini map and the skill tree's Essence
 * groups all take it from here.
 */
export const ESSENCE_COLORS: Readonly<Record<EssenceType, string>> = {
  resonance: '#cccccc',
  memory: '#44d98a',
  courage: '#ffd700',
  sorrow: '#2f6bff',
  fury: '#ff4444',
  truth: '#dd00ff',
};

/**
 * Get color for essence type (for UI display).
 */
export function getEssenceColor(type: EssenceType): string {
  return ESSENCE_COLORS[type];
}

/** An essence type's color; Resonance's, for something with no essence type (an empty orb, a plain item). */
export function resolveEssenceColor(type: EssenceType | undefined): string {
  return ESSENCE_COLORS[type ?? 'resonance'];
}
